import { SubscriptionDetailInfo } from "../../utils/getSubscriptionDetailInfo";
import { RootState, WorkspaceState } from "../types";

export const getWorkspaceId = (state: RootState): WorkspaceState["currentId"] => state.workspace.currentId;

export const getWorkspaceSubscriptionInfo = (state: RootState): SubscriptionDetailInfo =>
  state.workspace.subscriptionInfo;
